import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RichTextWithExtractedImages from '../CorrectionContent/RichTextWithExtractedImages';

const ExplanationSection = ({ state }) => {
  const { t } = useTranslation();

  const [valueAntwoord, setValueAntwoord] = useState(
    state?.antwoord ? state?.antwoord : ''
  );
  useEffect(() => {
    if (state) {
      const value = valueAntwoord;
      setValueAntwoord(value.replace(/ contenteditable="true"/g, ''));
    }
  }, [state]);

  return (
    <>
      {state?.showAnswer &&
        state?.antwoord &&
        valueAntwoord !== '<p></p>' &&
        state?.type !== 'OpenVraag' && (
          <div className="rounded-lg bg-[#f8f8f9] pt-4">
            <div className="flex w-full items-center">
              <p className="text-sm font-semibold text-black">
                {state?.type !== 'FileUpload'
                  ? `${t('widgets.type.explanation')}:`
                  : `${t('widgets.type.correction_key')}:`}
              </p>
            </div>

            {state?.type !== 'FileUpload' ? (
              <div
                className="text-sm font-normal text-grey-05"
                dangerouslySetInnerHTML={{
                  __html: valueAntwoord,
                }}
              ></div>
            ) : (
              <RichTextWithExtractedImages html={valueAntwoord} />
            )}
          </div>
        )}
    </>
  );
};

export { ExplanationSection };
